"use client";

import Link from "next/link";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const PAGE_ID_PREFIX = "cookies";

export default function CookiesPage() {
  return (
    <div
      id={`${PAGE_ID_PREFIX}-page`}
      className="flex min-h-screen flex-col bg-slate-950 text-slate-50"
    >
      <Header idPrefix={`${PAGE_ID_PREFIX}-header`} />

      <main
        id={`${PAGE_ID_PREFIX}-main`}
        className="flex flex-1 flex-col px-4 py-10"
      >
        <article className="mx-auto w-full max-w-2xl space-y-6 text-sm text-slate-300">
          <h1
            id={`${PAGE_ID_PREFIX}-title`}
            className="text-2xl font-semibold text-slate-100"
          >
            Cookies &amp; browser storage
          </h1>
          <p className="leading-relaxed">
            Punk Records is a static site. The notice at the bottom is
            informational and does not block navigation. We do not use
            third‑party advertising cookies.
          </p>

          <section className="space-y-2" aria-labelledby={`${PAGE_ID_PREFIX}-h-analytics`}>
            <h2
              id={`${PAGE_ID_PREFIX}-h-analytics`}
              className="text-base font-semibold text-slate-100"
            >
              Analytics (Google Analytics 4)
            </h2>
            <p className="leading-relaxed">
              We use{" "}
              <strong className="font-medium text-slate-200">
                Google Analytics 4
              </strong>{" "}
              (Google LLC) to measure how the site is used—such as page views,
              general location (region/city level), device type, and how you
              move through the site. GA4 may set{" "}
              <strong className="font-medium text-slate-200">cookies</strong> or
              use similar storage on your device and send usage data to Google
              according to Google’s policies. Measurement ID:{" "}
              <code className="rounded bg-slate-800 px-1 py-0.5 font-mono text-xs text-slate-200">
                G-EP9K2PXHRM
              </code>
              . You can clear or block cookies in your browser settings. See{" "}
              <a
                href="https://policies.google.com/privacy"
                className="text-blue-400 hover:underline"
                target="_blank"
                rel="noreferrer"
              >
                Google’s Privacy Policy
              </a>{" "}
              and{" "}
              <a
                href="https://policies.google.com/technologies/partner-sites"
                className="text-blue-400 hover:underline"
                target="_blank"
                rel="noreferrer"
              >
                how Google uses data from sites that use its services
              </a>
              .
            </p>
          </section>

          <section className="space-y-2" aria-labelledby={`${PAGE_ID_PREFIX}-h-local`}>
            <h2
              id={`${PAGE_ID_PREFIX}-h-local`}
              className="text-base font-semibold text-slate-100"
            >
              Local storage
            </h2>
            <p className="leading-relaxed">
              We may store preferences and data you generate (for example dark/light
              theme, search or collection helpers) in your browser using{" "}
              <strong className="font-medium text-slate-200">local storage</strong>.
              That data stays on your device unless you clear site data in your
              browser.
            </p>
          </section>

          <section className="space-y-2" aria-labelledby={`${PAGE_ID_PREFIX}-h-cookies`}>
            <h2
              id={`${PAGE_ID_PREFIX}-h-cookies`}
              className="text-base font-semibold text-slate-100"
            >
              Cookies
            </h2>
            <p className="leading-relaxed">
              Besides analytics, we do not use cookies for advertising. If we
              add features that rely on extra cookies (for example signed‑in
              accounts), we will describe them here.
            </p>
          </section>

          <p className="text-xs text-slate-500">
            This page is for transparency only and is not legal advice. Adjust
            the text to match your jurisdiction and what your deployment
            actually does.
          </p>

          <p>
            <Link
              href="/"
              className="text-blue-400 hover:underline"
            >
              ← Back to home
            </Link>
          </p>
        </article>
      </main>

      <Footer idPrefix={`${PAGE_ID_PREFIX}-footer`} />
    </div>
  );
}
